// extracted by mini-css-extract-plugin
export default {"badge":"notification-badge_badge__RvsgO","dot":"notification-badge_dot__k76ML"};